export const getCookie = (name) => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? match[2] : null;
};
export const setCookie = (key, value) => {
    document.cookie = `${key}=${value};path=/`;
};
export const clearCookie = (key) => {
    document.cookie = `${key}=;expires=${new Date(0).toUTCString()};path=/`;
};
